<!--
 * @Author: niuziji 18752021112@163.com
 * @Date: 2023-01-30 11:37:45
 * @LastEditors: niuziji 18752021112@163.com
 * @LastEditTime: 2023-02-22 09:57:39
 * @FilePath: \jmseg-vip-customers-front\src\views\place-order\reserveCode-order\components\donmLoadReserveCode.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-dialog
      lock-scroll
      :modal-append-to-body="false"
      :append-to-body="true"
      :title="$lang('预取号下载')"
      :close-on-click-modal="false"
      :visible.sync="downloadReserveCodeVisible"
      @close="close"
      width="800px"
      top="0px"
    >
      <el-form :model="form" ref="sizeForm" :rules="rule" :inline="true" label-suffix=":" class="form-class">
        <el-form-item :label="$lang('预取号数量')" prop="generateNumber">
          <el-input v-model="form.generateNumber" :placeholder="$lang('请输入')" maxlength='4'></el-input>
          <span class="num-tips">{{ $lang('请输入') }}1-3000</span>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="save" :loading="loading">{{ $lang('确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RULES } from '@utils/rules'
import { prefetchNumberOrder } from '@api/module/customer'
export default {
  name: 'DownloadReserveCode',
  props: {
    downloadReserveCodeVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      form: {
        generateNumber: ''
      },
      rule: {
        generateNumber: [RULES.required, RULES.checkNum]
      }
    }
  },
  watch: {
    'form.generateNumber'(val) {
      this.form.generateNumber = val === '0' ? '' : val.replace(/[^\d]/g, '')
    }
  },
  methods: {
    // 确定
    save() {
      this.$refs.sizeForm.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true
            const params = {
              generateNumber: this.form.generateNumber
            }
            const res = await prefetchNumberOrder(params)
            if (res && res.succ) {
              window.location.href = res.data.url
              this.close()
            } else {
              this.$message.error(res.msg)
            }
            this.loading = false
          } catch (err) {
            this.loading = false
          }
        }
      })
    },
    close() {
      this.form.generateNumber = ''
      this.$emit('update:downloadReserveCodeVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-class {
  text-align: center;
}
.num-tips {
  display: inline-block;
  margin-left: 10px;
}
</style>

